export enum actionTypes {
    SET_ADDRESSES = 'SET_ADDRESSES',
    SET_FINDED_ADDRESSES = 'SET_FINDED_ADDRESSES',
    SET_IS_LOADING_NEAREST_CLUBS = 'SET_IS_LOADING_NEAREST_CLUBS',
    SET_CLUB_DATA = 'SET_CLUB_DATA',
    SET_CLUBS_LIST = 'SET_CLUBS_LIST',
    SET_GEO_SEARCH = 'SET_GEO_SEARCH',
    SET_IS_CLUB_LIST_LOADED = 'SET_IS_CLUB_LIST_LOADED'
}
